import { motion } from "framer-motion";

// Underline-style tabs (NOT buttons) that segregate the journeys.
// variant="bar"    → sticky bar (used on mobile, below the auto-hiding header)
// variant="inline" → bare row (used inside the desktop header, between logo & CTAs)
// Active = full opacity + sliding underline; inactive = dimmed.
export const JourneyTabs = ({ options, active, onSelect, variant = "bar", className = "" }) => {
  if (!options || options.length <= 1) return null;

  const buttons = options.map((o) => {
    const isActive = o.key === active;
    return (
      <button
        key={o.key}
        type="button"
        data-testid={`journey-tab-${o.key}`}
        onClick={() => onSelect(o.key)}
        className="relative shrink-0 pb-1 text-sm font-medium tracking-wide transition-opacity duration-300"
        style={{ opacity: isActive ? 1 : 0.55 }}
      >
        <span className={isActive ? "text-amber-200" : "text-amber-100"}>{o.label}</span>
        {isActive && (
          <motion.span
            layoutId={`journey-underline-${variant}`}
            className="absolute inset-x-0 -bottom-1.5 h-[2px] rounded-full bg-amber-300"
          />
        )}
      </button>
    );
  });

  if (variant === "inline") {
    return (
      <div
        data-testid="journey-tabs-inline"
        className={`flex items-center gap-6 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}
      >
        {buttons}
      </div>
    );
  }

  return (
    <div
      data-testid="journey-tabs-bar"
      className={`sticky top-0 z-30 border-y border-amber-300/15 bg-[#070b18]/95 shadow-[0_8px_20px_-8px_rgba(0,0,0,0.6)] backdrop-blur-lg ${className}`}
    >
      <div className="mx-auto flex max-w-6xl gap-7 overflow-x-auto px-5 py-3.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {buttons}
      </div>
    </div>
  );
};
